export const DEFAULT_OUTLINE_THICKNESS = 4;
